/* eslint-disable @typescript-eslint/no-explicit-any */
import { Html, Line } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { useRef } from 'react';
import { useGesture } from '@use-gesture/react';
import { useSpring, a } from '@react-spring/three';
import * as THREE from 'three';
import { useNavMeshContext } from '@slope/navmesh/r3f';

const raycaster = /*@__PURE__ */ new THREE.Raycaster();
raycaster.firstHitOnly = true;

export function Pivot({
  position,
  //onUpdate,
}: {
  position: THREE.Vector3;
  onUpdate: (v: THREE.Vector3) => void;
}) {
  const { query } = useNavMeshContext();

  const ref = useRef<THREE.Mesh>(null!);
  const { camera, /*, , scene,  scene, size,*/ controls, pointer } = useThree();

  const [{ scale, ...restSprings }, setSprings] = useSpring(() => ({
    scale: [1, 1, 1],
    position: [position.x, position.y, position.z],

    config: { mass: 1, friction: 40, tension: 600 },
  }));

  //const aspect = size.width / viewport.width;

  const bind = useGesture({
    onDrag: ({ last }) => {
      (controls as any).enabled = last;
      raycaster.setFromCamera(pointer, camera);
      const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0); // y=0 plane
      const projected = new THREE.Vector3();
      raycaster.ray.intersectPlane(plane, projected);

      if (!projected) return;

      const match = query?.findClosestPoint(projected, {
        halfExtents: new THREE.Vector3(5, 5, 5),
      });

      if (match) {
        setSprings({
          position: match?.point
            ? [match.point.x, match.point.y, match.point.z]
            : [projected.x, projected.y, projected.z],
        });
      }
    },
    onHover: ({ hovering }) => setSprings({ scale: hovering ? [2, 2, 2] : [1, 1, 1] }),
  });

  return (
    // @ts-expect-error type mismatch with useGesture
    <a.group ref={ref} name="Pivot" {...restSprings} {...bind()}>
      {/* @ts-expect-error type mismatch with useGesture */}
      <a.mesh scale={scale} position={[0, 2, 0]} castShadow>
        <sphereGeometry args={[0.5]} />
        <meshBasicMaterial color="#1c60b9" />
        <Html center position={[0, 1, 0]} style={{ pointerEvents: 'none' }}>
          <a.div
            style={{
              background: 'black',
              color: 'white',
              padding: '2px 4px',
              borderRadius: 4,
              fontSize: 12,
            }}
          >
            {restSprings.position.to(
              (x, y, z) => `(${x.toFixed(2)}, ${y.toFixed(2)}, ${z.toFixed(2)})`,
            )}
          </a.div>
        </Html>
      </a.mesh>
      <Line
        points={[
          [0, 0, 0],
          [0, 2, 0],
        ]}
        color="black"
        lineWidth={2}
        dashed={false}
      />
    </a.group>
  );
}
